/**
 * ワークフロー雛形エディタ用プリセット定数。
 * mock-app の CaseTemplates.razor から移植 → spec workflow-templates.md に整合。
 *
 * リンク先画面の選択肢 (map / GROUPS / RECOMMENDED / 推奨解決) は
 * `~/pages/AdminWorkflowTemplates/models/linkedPageOptions` に集約した。
 * 旧 import 元との互換のため、本ファイルからも re-export する。
 *
 * 本ファイルが直接持つのは大ステップタイトルプリセット (BIG_STEP_TITLE_PRESETS) のみ。
 */

// ─── リンク先画面の選択肢 (linkedPageOptions に集約) の互換 re-export ─────────
export {
  LINKED_PAGE_KIND_GROUPS,
  RECOMMENDED_LINKED_PAGE_MAP,
  resolveRecommendedLinkedPageKinds,
} from '~/pages/AdminWorkflowTemplates/models/linkedPageOptions'
export type {
  LinkedPageKindItem,
  LinkedPageKindGroup,
  BigStepTitle,
} from '~/pages/AdminWorkflowTemplates/models/linkedPageOptions'

// ─── 大ステップタイトルプリセット（spec P0 6 種）──────────────────────
//
// spec workflow-templates.md AC-WFT-008 /「機能詳細 2. 大ステップのタイトル
// プリセット」 が SoT。 P0 は業務フロー順の 6 種 + 「その他」 (自由入力)。
// 「その他」 は select 側 (BigStepEditor の CUSTOM_VALUE) が担うため本配列には含めない。
// P1 以降の候補語 (需要予測 / 需要見直し / 通告 / 通告変更 / 計画作成 /
// レポート / 気象確認 / 精算 等) は spec §機能詳細 2 に追記されたタイミングで
// 本配列に追加する (#4552: 「需要想定」と「需要予測」の重複解消)。
// 既存雛形に保存済みの非プリセットタイトルは「その他 (自由入力)」として
// 表示・編集できるため、 本縮減によるデータ破壊はない。
// 組み込み雛形 (wf-spot / wf-intraday / wf-today-revise) の大ステップタイトル
// は本プリセットに統一済み (2026-09-03 spec 追従で wf-today-revise は
// 「需要想定」「時間前入札」「計画提出」の3ステップに変更、旧「同時同量監視」
// ステップは削除。 issue #7132)。 組み込み雛形は wf-spot / wf-intraday /
// wf-today-revise の3種のみ (旧 wf-dayaftertomorrow は退役。 issue #7241)。
// 「同時同量監視」プリセット自体は組み込み雛形からは参照されなくなったが、
// AC-WFT-008 の P0 プリセットとしてユーザー雛形向けに残す (下記配列参照)。
export type BigStepTitlePreset = {
  title: string
}

export const BIG_STEP_TITLE_PRESETS: BigStepTitlePreset[] = [
  { title: '需要想定' },
  { title: '供給力確認' },
  { title: 'スポット入札' },
  { title: '時間前入札' },
  { title: '計画提出' },
  { title: '同時同量監視' },
]
